import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}

//录播视频获取所有视频列表 -- 张
getData.getVideos = (data)=>{ 
    return http.get(baseUrl+"/video/videos/",{ params:data })
}

//新增录播视频 -- 张
getData.addVideos = (data)=>{ 
    return http.post(baseUrl+"/video/videos/",data)
}
//获取单个录播视频 -- 张
getData.getVideo = (pk,data)=>{
    return new Promise((resolve, reject) => {
      http.get(baseUrl+"/video/video/"+pk+'/',{ params:data }).then((res) => {
          if(res.data.code == 200){
              let xx = res.data.data
                xx.k_icon ? xx.icon = xx.icon.replace("/api", "/api/media"):xx.k_icon;
                res.data.data=xx
                resolve(res)
          }else{
              resolve(res)
          }
      }).catch((err) => {
          reject(err)
      });
    })
    // return http.get(baseUrl+"/video/video/"+pk+"/",{ params:data })
}
//修改录播视频 -- 张
getData.editVideo = (pk,data)=>{ 
    return http.put(baseUrl+"/video/video/"+pk+"/",data)
}
//删除录播视频 -- 张
getData.deleteVideo = (pk,data)=>{ 
    return http.delete(baseUrl+"/video/video/"+pk+"/",data)
}
//草稿视频发布为录播视频 -- 张
getData.releaseVideo = (pk,data)=>{ 
    return http.patch(baseUrl+"/video/video/"+pk+"/",data)
}

// =================录播视频前台部分功能接口===================
//前台--录播视频获取相关推荐视频列表 -- 张
getData.getRecomVideos = (id,data)=>{ 
    return http.get(baseUrl+"/video/videos/?recom=1&draft=false"+`${id?"&video_id="+`${id}`:''}`,{ params:data })
}
//前台--录播视频收藏功能 -- 张
getData.collectVideos = (data)=>{ 
    return http.post(baseUrl+"/video/colvideo/",data)
}
//前台--录播视频点赞功能 -- 张
getData.likeVideos = (data)=>{ 
    return http.post(baseUrl+"/video/likevideo/",data)
}
//前台--根据上传人信息获取录播视频列表 -- 张
getData.getUserVideos = (page,pageSize,id,data)=>{ 
    return http.get(baseUrl+"/video/videos/?page="+page+"&page_size="+pageSize+"&user_id="+id+"&draft=false",{ params:data })
}
//前台--我的关注删除浏览记录 -- 张
getData.delLikeVideo = (data)=>{ 
    return http.post(baseUrl+"/video/delvbrowse/",data)
}

//前台--我的关注列表涉及到的标签 -- 张
getData.getfilterTags = (data)=>{ 
    return http.get(baseUrl+"/video/tags/",{ params:data })
}
//前台--录播视频获取评论列表 -- 张
getData.getVcoms = (id,data)=>{ 
    return http.get(baseUrl+"/video/vcoms/?video_id="+id,{ params:data })
}
//前台--录播视频获取我的评论列表 -- 张
getData.getMyVcoms = (id,data)=>{ 
    return http.get(baseUrl+"/video/vcoms/?video_id="+id+"&my=1",{ params:data })
}
//前台--录播视频发表评论 -- 张
getData.addVcoms = (data)=>{ 
    return http.post(baseUrl+"/video/vcoms/",data)
}
//前台--录播视频删除发表的评论 -- 张
getData.deleteVcom = (id,data)=>{ 
    return http.delete(baseUrl+"/video/vcom/"+id+"/",data)
}







export default getData


// WEBPACK FOOTER //
// ./src/common/recordVideo.js